import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Navigate, Route, Router, Routes, BrowserRouter } from 'react-router-dom';

//styles maquinas
import { errorMachine, PromiseSesionContext } from './machines/ErrorMachine';
import { useMachine } from '@xstate/react';
import ErrorHandler from './errorHandler/ErrorHandler';
import Layout from './pageLayout/Layout';
import Products from './pages/products/Products';
import { sesionMachine } from './machines/SesionMachine';
import Inventario from './pages/inventario/Inventario';
import CreateProduct from './pages/createProduct/CreateProduct';
import Welcome from './pages/welcome/Welcome';
import { GlobalDataProvider } from './context/GlobalContext';

function App() {
  const [error, sendError] = useMachine(errorMachine)
  const [sesion, sendSesion] = useMachine(sesionMachine)


  return (
    <GlobalDataProvider>
      <BrowserRouter>
        <PromiseSesionContext.Provider value={{ error, sendError, sesion, sendSesion}}>
          <ErrorHandler>
            <Layout>
              <Routes>
                {/* <Route path='/inicio' element={<Welcome />} /> */}
                <Route path='/' element={<Products />} />


                {/* admin */}
                {/* <Route path='/inventario' element={<Inventario />} /> */}
                {/* <Route path='/crear-producto' element={<CreateProduct />} /> */}





                <Route path="*" element={<Navigate to="/" replace />}/>
              </Routes>
            </Layout>
          </ErrorHandler>
        </PromiseSesionContext.Provider>
      </BrowserRouter>
    </GlobalDataProvider>
  );
}

export default App;
